import Chat from "@/components/Chat/Chat";
import Control from "@/components/Controls/Control";
import Details from "@/components/Details/Details";
import NavBar from "@/components/NavigationBar/NavBar";
import InactivityWarningModal from "@/components/InactivityWarningModal";
import SessionExpiredModal from "@/components/SessionExpiredModal";
import { selectIsDetailsPaneOpen } from "@/features/details/detailsSlice";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { useInactivityTimer } from "@/hooks/useInactivityTimer";
import { logout } from "@/features/auth/authSlice";

/**
 * Layout component for the chat interface.
 *
 * @returns {React.ReactElement} The chat layout with control and chat sections.
 */
const ChatLayout = (): React.ReactElement => {
  const dispatch = useAppDispatch();
  const isDetailsPaneOpen = useAppSelector(selectIsDetailsPaneOpen);
  const { showWarning, countdown, stayLoggedIn, sessionExpired } = useInactivityTimer();

  return (
    // h-dvh (not h-screen): on iOS Safari 100vh includes the area behind the
    // retractable toolbars, which pushes the message input off-screen.
    <div className="flex flex-col h-dvh bg-white pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]">
      {showWarning && <InactivityWarningModal countdown={countdown} onStayLoggedIn={stayLoggedIn} />}
      {sessionExpired && <SessionExpiredModal onLogIn={() => dispatch(logout())} />}
      <NavBar/>
      <main className="flex items-center justify-center flex-1 min-h-0 py-0 md:py-[4vh] overflow-auto bg-neutral-100 text-neutral-600">
        <section
          className={`grid w-full md:w-[90%] grid-cols-1 ${
            isDetailsPaneOpen ? "md:grid-cols-4" : "md:grid-cols-3"
          } border-0 md:border bg-white rounded-none md:rounded-md border-neutral-300 h-full`}
        >
          <Control />
          <Chat />
          {isDetailsPaneOpen && <Details/>}
        </section>
      </main>
    </div>
  );
};

export default ChatLayout;
